var Type = /* @__PURE__ */ ((Type2) => {
  Type2["danger"] = "danger";
  Type2["base"] = "base";
  Type2["positive"] = "positive";
  Type2["neutral"] = "neutral";
  Type2["alert"] = "alert";
  Type2["dark"] = "dark";
  Type2["basic"] = "basic";
  Type2["advanced"] = "advanced";
  Type2["premium"] = "premium";
  return Type2;
})(Type || {});
const WsTagEnum = {
  Type
};
export {
  Type,
  WsTagEnum
};
//# sourceMappingURL=WsTag.enum.es.js.map
